const deliveryMessage = {
  main: '本日11/8(日)はボランティアスタッフ人数の関係により、デリバリー提供時間は11時～14時までとさせて頂きます。',
  sub: '本日11/7(土)はデリバリー中止とお知らせしましたが、降水確率と皆様の利便性を考慮し、15:00までデリバリーを受け付けいたします。',
}

export default deliveryMessage